// @ts-nocheck
import React from 'react'

import { Box } from 'components/layout/Box/Box'
import { ProgressWidget } from 'components/shared/ProgressWidget/ProgressWidget'
import { Table } from 'components/shared/Table/Table'

import {
  getDefaultProjectQueryParams,
  getProjectTab,
  mapTypeToLabel,
  mapTypeToSteps,
} from './model'

export const JobProgressCell = ({
  label,
  progress = 0,
  status,
  steps,
  type,
  onClick,
  hasIncreasedHeight,
  hasInterviewModule,
}) => {
  const param = type === 'candidate' ? status : progress
  const progressSteps = steps ?? mapTypeToSteps[type]({ hasInterviewModule })
  const progressLabel =
    label ?? mapTypeToLabel[type](param, { hasInterviewModule })

  return (
    <Table.Cell type="body" {...{ hasIncreasedHeight }}>
      <Box align="center" justify="center" tagName="span">
        <ProgressWidget
          steps={progressSteps}
          progress={progress}
          label={progressLabel}
          queries={getDefaultProjectQueryParams}
          tabs={getProjectTab}
          {...{ onClick }}
        />
      </Box>
    </Table.Cell>
  )
}
